<template>
  <v-menu
    offset-y
    :left="left"
    :right="right"
    min-width="176"
  >
    <v-tooltip
      v-if="typeof tooltip === 'string'"
      top
      slot="activator"
      max-width="172px"
    >
      <v-btn
        slot="activator"
        :disabled="!Object.keys(filesFiltered).length"
        flat
        icon
        class="dropdown-actions__activator gray-6--text mx-0"
        @click.prevent
      >
        <v-icon color="gray-6">{{ icon || 'get_app' }}</v-icon>
      </v-btn>
      <span>{{ tooltipText || $t(`${namespace}.downloadMessage`) }}</span>
    </v-tooltip>

    <v-btn
      v-else
      slot="activator"
      :disabled="!Object.keys(filesFiltered).length"
      flat
      icon
      class="mr-0 dropdown-actions__activator gray-6--text"
    >
      <v-icon>{{ icon || 'get_app' }}</v-icon>
    </v-btn>

    <v-list class="dropdown-actions__list">
      <v-list-tile
        v-for="(file, item) in filesFiltered"
        :key="item"
      >
        <a
          :href="file ? file : null"
          :title="$t(`${namespace}.${item}`)"
          :class="{ 'disabled': !file  }"
          :target="item === 'nfeUrl' ? '_blank' : null"
          :rel="item === 'nfeUrl' ? 'noopener noreferrer' : null"
        >
          {{ $t(`${namespace}.${item}`) }}
        </a>
      </v-list-tile>

      <div v-if="hasRole('billing', 'ROLE_POST_DUPLICATE_INVOICE') && (status === 'AUTHORISED' || status === 'INVOICE_SENT' || status === 'LATE')">
        <v-divider />

        <v-list-tile v-if="status === 'LATE'">
          <router-link
            :to="reissueBilletLink"
            :title="$t(`${namespace}.reissueBillet`)"
          >
            {{ $t(`${namespace}.reissueBillet`) }}
          </router-link>
        </v-list-tile>

        <v-list-tile
          v-if="
            hasRole('billing', 'ROLE_GET_ORDER_SUMMARY_UPDATED') &&
            hasRole('billing', 'ROLE_POST_DUPLICATE_INVOICE') &&
            (status === 'AUTHORISED' || status === 'INVOICE_SENT')
          "
        >
          <router-link
            :to="{
              name: 'InvoiceExtendDueDate',
              params: {
                invoiceId: invoice.id,
                dueDateOpt: formatDate(invoice.dueDateOpt)
              }
            }"
            :title="$t(`${namespace}.extendMaturity`)"
          >
            {{ $t(`${namespace}.extendMaturity`) }}
          </router-link>
        </v-list-tile>
      </div>
    </v-list>
  </v-menu>
</template>

<script>
import moment from 'moment'
import { hasRole } from 'utils/functions'

export default {
  name: 'FinancialDropdownActions',
  props: {
    tooltip: {
      type: String,
      default: null
    },
    tooltipText: {
      type: String,
      default: null
    },
    files: {
      type: Object,
      default: null
    },
    left: {
      type: Boolean,
      default: false
    },
    right: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: 'get_app'
    },
    status: {
      type: String,
      default: null
    },
    invoice: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    filesFiltered () {
      const obj = { ...this.files }

      return {
        debitNoteUrl: obj['debitNoteUrl'] || null,
        receiptUrl: obj['receiptUrl'] || null,
        billetUrl: obj['boletoUrl'] || obj['billetUrl'] || null,
        taxiJobReportUrl: obj['taxiJobReportUrl'] || null,
        serviceTaxiJobReportUrl: obj['serviceTaxiJobReportUrl'] || null,
        nfeUrl: obj['nfeUrl'] || null
      }
    },

    dueDateOptExpired () {
      const today = moment().format('x')
      const dueDateOptLimit = moment(this.invoice.dueDateOpt).add(5, 'days').format('x')
      return Number(today) > Number(dueDateOptLimit)
    },

    reissueBilletLink () {
      const dueDateOpt = this.formatDate(this.invoice.dueDateOpt)

      return this.dueDateOptExpired && !hasRole('billing', 'ROLE_POST_DUPLICATE_INVOICE_ENABLE_EDIT_DUE_DATE') ? {
        name: 'InvoiceExtendDueDateExpiredRequests',
        params: {
          date: dueDateOpt
        }
      } : {
        name: 'InvoiceExtendDueDate',
        params: {
          invoiceId: this.invoice.id,
          dueDateOpt
        }
      }
    }
  },
  data () {
    return {
      namespace: 'Components.FinancialDropdownActions2'
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    formatDate (dueDateOpt, format = 'x') {
      return moment(dueDateOpt).format(format)
    }
  }
}
</script>
